import src from "IMAGE";
export default { src, width: 48, height: 35, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
